import { render, staticRenderFns } from "./Map2D.vue?vue&type=template&id=dd7c28cc&scoped=true&"
import script from "./Map2D.vue?vue&type=script&lang=js&"
export * from "./Map2D.vue?vue&type=script&lang=js&"
import style0 from "./Map2D.vue?vue&type=style&index=0&id=dd7c28cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7c28cc",
  null
  
)

export default component.exports